import { Avatar, Badge, Icon, BlockStack, Button, InlineStack, Link, Page, Text } from "@shopify/polaris"
import { ArrowLeftIcon, DeleteIcon, ExternalIcon, HideIcon, LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon, SendIcon, ViewIcon } from "@shopify/polaris-icons"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import SearchProfile from "../../components/creators/SearchProfile"
import AppLayout from "../../components/layout"
import { usePartnerUp } from "../../providers/PartnerUpStoreProvider"
import { getBestAvatar } from "../../utils"

export default function Profile() {
  const { leads, setInviteModalState } = usePartnerUp();
  const navigate = useNavigate();
  const location = useLocation();

  const [deleteOpen, setDeleteOpen] = useState(false)
  const [hideLoading, setHideLoading] = useState(false)
  const [localHidden, setLocalHidden] = useState(false)
  const [hasDeal, setHasDeal] = useState(false)

  const creatorOpen = leads?.find(lead => lead.id === location.pathname.split('/')[2])

  console.log('creatorOpen', creatorOpen)
  return (
    <AppLayout>
      <Button size="large" icon={ArrowLeftIcon} onClick={() => navigate(-1)}>Back</Button>
      <Page
        // breadcrumbs={[{ content: 'Back', onAction: backAction }]}
        fullWidth
        title={<InlineStack gap="200" align="start">
          <InlineStack gap="200" blockAlign="center">
            <Avatar shape="square" source={creatorOpen?.picture} size="xl" />
            <BlockStack>
              <InlineStack>
                <InlineStack>
                  {
                    creatorOpen?.platform === 'instagram' ? (
                      <Icon source={LogoInstagramIcon} color="subdued" />
                    ) : creatorOpen?.platform === 'tiktok' ? (
                      <Icon source={LogoTiktokIcon} color="subdued" />
                    ) : creatorOpen?.platform === 'youtube' ? (
                      <Icon source={LogoYoutubeIcon} color="subdued" />
                    ) : null
                  }
                </InlineStack>
                <Link external removeUnderline url={`https://www.${creatorOpen?.platform}.com/${creatorOpen?.platform !== 'instagram' ? '@' + creatorOpen?.handle : creatorOpen?.handle}`}>
                  <Text variant="bodyLg">{creatorOpen?.handle ? `@${creatorOpen?.handle}` : creatorOpen?.platform}</Text>
                </Link>
                {/*
              <Text variant="bodyMd">
                {creatorOpen?.country ? `${getCountry(creatorOpen?.country)}${profileData?.city ? `, ${profileData.city} ` : ''}` : null}
              </Text>
            */}
              </InlineStack>
              <InlineStack gap="200" blockAlign="center">
                <Text variant="headingLg">{creatorOpen?.name}</Text>
                {
                  creatorOpen?.hidden ? (
                    <Badge status="warning">Hidden</Badge>
                  ) : null
                }
              </InlineStack>
            </BlockStack>
          </InlineStack>
        </InlineStack>}
        // open={creatorOpen?.userId}
        secondaryActions={
          [
            {
              content: `${creatorOpen?.platform ? creatorOpen?.platform[0]?.toUpperCase() + creatorOpen?.platform?.slice(1) : ''} Profile`,
              external: true,
              icon: ExternalIcon,
              url: `https://www.${creatorOpen?.platform}.com/${creatorOpen?.platform !== 'instagram' ? '@' + creatorOpen?.handle : creatorOpen?.handle}`
            },
          ]}
        actionGroups={creatorOpen?.id ? [
          {
            title: 'More Actions',
            actions: [
              (localHidden || creatorOpen?.hidden) ? {
                content: 'Unhide',
                icon: ViewIcon,
                loading: hideLoading,
                onAction: () => {
                  hide(false)
                }
              } : {
                content: 'Hide',
                icon: HideIcon,
                loading: hideLoading,
                onAction: () => {
                  hide(true)
                }
              },
              {
                content: 'Delete',
                icon: DeleteIcon,
                destructive: true,
                onAction: () => setDeleteOpen(true)
              }
            ]
          }
        ] : []}
      >
        <SearchProfile
          profileData={creatorOpen}
          onClose={() => navigate(-1)}
        />
      </Page>
    </AppLayout>
  )
}
